export default __webpack_public_path__ + "static/media/9.fa1fe5a7.jpg";